<template>
  <mmp-modal v-bind="commonAlertConfirmAttrs" v-on="listeners">
    <template v-slot:header>
      <div v-dompurify-html="title"/>
      <button type="button" class="btn_close" @click="$emit('close')"><span class="blind">팝업 닫기</span></button>
    </template>
    <template v-slot:content>
      <div v-dompurify-html="contents" />
      <div v-if="!isAlert" class="btn_wrap">
        <button type="button" class="btn_basic btn_basic_line" @click="$emit('close', false)"><span class="btn_text">{{ cancelBtnNm }}</span></button>
        <button type="button" class="btn_basic" @click="$emit('close', true)"><span class="btn_text">{{ okBtnNm }}</span></button>
      </div>
      <div v-else class="btn_wrap">
        <a href="javascript:void(0)" class="btn_basic" @click="$emit('close')"><span class="btn_text">{{ okBtnNm }}</span></a>
      </div>
    </template>
    <template v-slot:footer/>
  </mmp-modal>
</template>

<script>

export default {
  name: 'CommonAlertConfirm',
  props: {
    isAlert: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    contents: {
      type: String,
      default: ''
    },
    cancelBtnNm: {
      type: String,
      default: '취소'
    },
    okBtnNm: {
      type: String,
      default: '확인'
    }
  },
  data () {
    return {
    }
  },
  computed: {
    commonAlertConfirmAttrs () {
      return {
        ...this.componentAttrs,
        useDefaultHeader: false,
        useDefaultFooter: false,
        fullModal: false,
        mainclass: {
          'alert_type': this.isAlert
        }
      }
    }
  },
  /* vue lifecycle */
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  /* vue function */
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_common/mmp-popup/MmpAlertConfirmModal.vue